let userIdCache;

export const getCachedUserId = () => userIdCache;
export const setCachedUserId = id => (userIdCache = id);
